module.exports = __webpack_public_path__ + "img/University_of_Lapland-300x70.a184ca68.png";